import { render } from "./CatalogsSearchToolbar.vue?vue&type=template&id=0d3c95fe&ts=true"
import script from "./CatalogsSearchToolbar.vue?vue&type=script&lang=ts"
export * from "./CatalogsSearchToolbar.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Build\\TCF\\ABBp_PIS\\6.15.1\\PisNextGenExtProd-PisApp_6_15_1\\PisNextGenExtProd\\PisNextGen\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__